import { currency } from '@/utils'
import store from '@/store'

const statusColors = {
  0: 'red',
  1: 'cyan',
  2: 'blue',
  3: 'purple',
  9: 'green'
}

// const iconprops = {
//   0: 'close-round',
//   1: 'ios-more',
//   2: 'android-folder',
//   3: 'close-round',
//   9: 'checkmark-round'
// }
const types = {
  currencyNoZero: (h, ctx) => {
    if (isNullValue(ctx) || !ctx.props.value) return
    if (ctx.props.params && ctx.props.params.column && ctx.props.params.column.unit) {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(ctx.props.value / ctx.props.params.column.unit)
          }
        },
        currency(ctx.props.value / ctx.props.params.column.unit)
      )
    } else {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(ctx.props.value)
          }
        },
        currency(ctx.props.value)
      )
    }
  },
  currency: (h, ctx) => {
    if (isNullValue(ctx)) return
    if (ctx.props.params && ctx.props.params.column && ctx.props.params.column.unit) {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(ctx.props.value / ctx.props.params.column.unit)
          }
        },
        currency(ctx.props.value / ctx.props.params.column.unit)
      )
    } else {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(ctx.props.value)
          }
        },
        currency(ctx.props.value)
      )
    }
  },
  absCurrency: (h, ctx) => {
    if (isNullValue(ctx)) return
    if (ctx.props.params && ctx.props.params.column && ctx.props.params.column.unit) {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(Math.abs(ctx.props.value) / ctx.props.params.column.unit)
          }
        },
        currency(Math.abs(ctx.props.value) / ctx.props.params.column.unit)
      )
    } else {
      return h(
        'p',
        {
          class: {
            right: ctx.props.alignEnable
          },
          attrs: {
            title: currency(Math.abs(ctx.props.value))
          }
        },
        currency(Math.abs(ctx.props.value))
      )
    }
  },
  negateCurrency: (h, ctx) => {
    if (isNullValue(ctx)) return
    if (ctx.props.params && ctx.props.params.column && ctx.props.params.column.unit) {
      return h(
        'p',
        {
          class: {
            right: true
          },
          attrs: {
            title: currency((ctx.props.value * -1) / ctx.props.params.column.unit)
          }
        },
        currency((ctx.props.value * -1) / ctx.props.params.column.unit)
      )
    } else {
      return h(
        'p',
        {
          class: {
            right: true
          },
          attrs: {
            title: currency(ctx.props.value * -1)
          }
        },
        currency(ctx.props.value * -1)
      )
    }
  },
  number: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h(
      'p',
      {
        class: {
          right: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.parent ? ctx.parent.$n(ctx.props.value) : ctx.props.value
        }
      },
      ctx.parent ? ctx.parent.$n(ctx.props.value) : ctx.props.value
    )
  },
  dict: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h(
      'p',
      {
        class: {
          right: ctx.props.alignEnable
        },
        attrs: {
          title: store.getters.dictMap[ctx.props.value]
        }
      },
      store.getters.dictMap[ctx.props.value]
    )
  },
  date: (h, ctx) => {
    if (isNullValue(ctx) || !+ctx.props.value) return
    return h(
      'p',
      {
        class: {
          center: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.props.value && ctx.parent ? ctx.parent.$d(ctx.props.value, 'short') : ''
        }
      },
      ctx.props.value && ctx.parent ? ctx.parent.$d(ctx.props.value, 'short') : ''
    )
  },
  dateTime: (h, ctx) => {
    if (isNullValue(ctx) || !+ctx.props.value) return
    return h(
      'p',
      {
        class: {
          center: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.props.value && ctx.parent ? ctx.parent.$d(ctx.props.value, 'long') : ''
        }
      },
      ctx.props.value && ctx.parent ? ctx.parent.$d(ctx.props.value, 'long') : ''
    )
  },
  string: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h(
      'p',
      {
        class: {
          left: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.props.value
        }
      },
      ctx.props.value
    )
  },
  blank: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h('p', {
      class: {
        left: ctx.props.alignEnable
      },
      attrs: {
        title: ctx.props.value
      },
      domProps: {
        innerHTML: ctx.props.value
          .split(' ')
          .map(str => {
            if (str === '') return '&nbsp;&nbsp;&nbsp;'
            return str
          })
          .join('')
      }
    })
  },
  boolean: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h(
      'p',
      {
        class: {
          center: ctx.props.alignEnable
        }
      },
      [
        h('Icon', {
          style: {
            color: ctx.props.value == 1 ? '#19be6b' : '#ed3f14'
          },
          props: {
            type: ctx.props.value == 1 ? 'check' : 'close'
          }
        })
      ]
    )
  },
  status: (h, ctx) => {
    if (isNullValue(ctx)) return
    return h(
      'Tag',
      {
        props: {
          color: statusColors[ctx.props.value]
        }
      },
      [
        // h('Icon', {
        //   props: {
        //     type: iconprops[params.row.status]
        //   }
        // }),
        h('span', ' ' + this.$conf.status[ctx.props.value])
      ]
    )
  },
  /** 以下只能用在column中，并需要传入params **/
  href: (h, ctx) => {
    return h(
      'p',
      {
        class: {
          center: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.props.value
        }
      },
      [
        h(
          'a',
          {
            on: {
              click: event =>
                ctx.props.params &&
                ctx.props.params.column.click &&
                ctx.props.params.column.click(ctx.props.params, event)
            }
          },
          ctx.props.value
        )
      ]
    )
  },
  operate: (h, ctx) => {
    return h(
      'p',
      {
        class: {
          center: ctx.props.alignEnable
        },
        attrs: {
          title: ctx.props.value
        }
      },
      [
        h(
          'Poptip',
          {
            props: {
              transfer: true
            },
            attrs: {
              placement: 'left',
              trigger: 'hover'
            }
          },
          [
            h(
              'div',
              {
                slot: 'content'
              },
              [ctx.props.params.column.renderOperate(h, ctx.props.params)]
            ),
            h('i', {
              style: {
                color: '#2d8cf0'
              },
              class: {
                fa: true,
                'fa-gear': true
              }
            })
          ]
        )
      ]
    )
  }
}

const isNullValue = ctx => {
  return (
    ctx.props.value === null ||
    ctx.props.value === undefined ||
    ctx.props.value === 'NULL' ||
    ctx.props.value === 'null'
  )
}

export default {
  name: 'RenderValue',
  functional: true,
  props: {
    value: {
      required: true
    },
    render: Function,
    params: Object,
    type: {
      type: String,
      default: 'string',
      validator(value) {
        return Object.keys(types).includes(value)
      }
    },
    alignEnable: {
      type: Boolean,
      default: true
    }
  },
  render: (h, ctx) => {
    if (ctx.props.params && ctx.props.params.row._summary && isNullValue(ctx)) {
      return
    }
    if (ctx.props.render) return ctx.props.render(h, ctx.props.value)
    return types[ctx.props.type] ? types[ctx.props.type](h, ctx) : null
  }
}
